import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';
import './styles.scss';
import { useRef } from 'react';

type ZoomableImageProps = {
    src: string;
    alt?: string;
};

export default function ZoomableImage({ src, alt }: ZoomableImageProps) {
    const transformRef = useRef<ReactZoomPanPinchRef | null>(null);

    return (
        <TransformWrapper
            initialScale={4}
            initialPositionX={-300}
            initialPositionY={-150}
            minScale={1}
            maxScale={4}
            wheel={{ step: 0.1 }}
            doubleClick={{ disabled: true }}
            pinch={{ step: 5 }}
            panning={{ velocityDisabled: true }}
            limitToBounds={true}
            ref={transformRef}
        >
            <TransformComponent
                wrapperStyle={{ width: '100%', height: '60vh', overflow: 'hidden', border: '1px solid rgba(117, 117, 117, 0.10)' }}
                contentStyle={{ width: "auto",
                    height: "auto",}}
            >
                <img
                    src={src}
                    alt={alt ?? 'Lageplan'}
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        display: 'block',
                        userSelect: 'none',
                        pointerEvents: 'none',
                    }}
                    onLoad={() => {
                        transformRef.current?.setTransform(-300, -150, 4);
                    }}
                />
            </TransformComponent>
        </TransformWrapper>
    );
}
